import React from "react";
import { Card, Skeleton } from "antd";

const DashboardLoader = () => {
  const active = true;

  return (
    <div className="w-100">
      <div className="row">
        <div className="col-md-12 p-0 px-3">
          <div className="flex justify-content-between align-items-center mb-4">
            <div className="flex gap-2">
              <Skeleton.Button
                active={true}
                style={{ width: "240px" }}
                size={"small"}
                block={false}
              />
            </div>
            {/* <div className="flex gap-2">
              <Skeleton.Button
                active={true}
                size={"small"}
                style={{ width: "170px" }}
                block={false}
              />
              <Skeleton.Button
                active={true}
                size={"small"}
                style={{ width: "10px" }}
                block={false}
              />
              <Skeleton.Button
                active={true}
                style={{ minWidth: "30px !important" }}
                size={"small"}
                block={false}
              />
            </div> */}
          </div>
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <Skeleton.Input
            className="mb-2"
            active={active}
            size={"small"}
            block={true}
          />
          <div className="flex justify-content-end align-items-center mb-2">
            <div className="flex gap-2">
              <Skeleton.Button
                active={true}
                style={{ width: "170px" }}
                size={"small"}
                block={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLoader;
